import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { clearAdminSession } from "../../helpers/adminAuth";
import {
  IconBarcode,
  IconClose,
  IconDashboard,
  IconLogout,
  IconMenu,
  IconTrophy,
  IconUsers,
} from "./AdminIcons";
import "../../Admin.scss";

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleLogout = () => {
    clearAdminSession();
    setMenuOpen(false);
    navigate("/admin/login");
  };

  return (
    <div className={`admin-app ${menuOpen ? "is-menu-open" : ""}`}>
      <header className="admin-header">
        <div className="admin-header-inner">
          <NavLink
            to="/admin"
            end
            className="admin-header-brand"
            onClick={() => setMenuOpen(false)}
          >
            <img src="/ultra-logo-2025.png" alt="Ultra" />
            <strong>Admin Panel</strong>
          </NavLink>

          <button
            type="button"
            className="admin-burger"
            aria-label={menuOpen ? "Zatvori meni" : "Otvori meni"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <IconClose /> : <IconMenu />}
          </button>

          <div className={`admin-header-menu ${menuOpen ? "is-open" : ""}`}>
            <nav className="admin-nav">
              <NavLink to="/admin" end onClick={() => setMenuOpen(false)}>
                <IconDashboard />
                <span>Dashboard</span>
              </NavLink>
              <NavLink to="/admin/takmicari" onClick={() => setMenuOpen(false)}>
                <IconUsers />
                <span>Takmičari</span>
              </NavLink>
              <NavLink to="/admin/kodovi" onClick={() => setMenuOpen(false)}>
                <IconBarcode />
                <span>Kodovi</span>
              </NavLink>
              <NavLink to="/admin/dobitnici" onClick={() => setMenuOpen(false)}>
                <IconTrophy />
                <span>Dobitnici</span>
              </NavLink>
            </nav>
            <button type="button" className="admin-logout" onClick={handleLogout}>
              <IconLogout />
              <span>Odjavi se</span>
            </button>
          </div>
        </div>
      </header>

      {menuOpen && (
        <button
          type="button"
          className="admin-menu-backdrop"
          aria-label="Zatvori meni"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
